export const regExEmail = new RegExp( '^[A-Za-z0-9_\\+-]+(\\.[A-Za-z0-9_\\+-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*\\.([A-Za-z]{2,6})$' )
export const regExSpecial = new RegExp( /[!@#$%\^&*(){}[\]<>?/|\-,."':;=/\\~`+_]/ )
export const regExLetter = new RegExp( /[a-zA-Z]/ )
export const regExNumber = new RegExp( /\d/ )
export const regExAlphaComaHyphen = new RegExp( /^[a-zA-Z0-9-,'\s]+$/i )
export const emailRegEx = 
{
    regEx: regExEmail,
    errorMsg: 'The Email address you submitted is not valid. Please try again, and double check your Email format (example: someone@example.com).',
}